<template>
  <div class="box">
    <div class="box-item">
      <img :src="$cdnPath.img + 'Activity/179/bg1.jpg'"/>
      <div class="box-get-vip" v-if="redeemCode==''">
        <img :src="$cdnPath.img + 'Activity/179/get-vip.png'"/>
        <div class="box-btn" @click="createCode()" :style="{backgroundImage:'url('+$cdnPath.img + 'Activity/179/btn.png)'}">领取VIP</div>
      </div>
      <div class="box-get-succ" v-else>
        <img :src="$cdnPath.img + 'Activity/179/get-succ.png'"/>
        <div class="box-get-succ-code">{{redeemCode}}</div>
        <div class="box-get-succ-time">可使用<span>{{total}}</span>次</div>
        <div class="box-btn" @click="copy" :class="'to-copy'" :data-clipboard-text="copyTxt" :style="{backgroundImage:'url('+$cdnPath.img + 'Activity/179/btn.png)'}">
          <div>分享给好友<br /> <span>（点击复制兑换码）</span></div>
        </div>
      </div>
    </div>
    <div class="box-item">
      <img :src="$cdnPath.img + 'Activity/179/bg2.png'"/>
      <div class="box-item-people"><span>{{getTimes}}</span>人</div>
    </div>
    <div class="box-item">
      <img :src="$cdnPath.img + 'Activity/179/bg3.png'"/>
      <div class="box-item-rule" @click="showRule"></div>
    </div>
  </div>
</template>

<script>
  import Clipboard from 'clipboard'
  import { fetch,post } from '@/api/appRequest.js';
  import API from '@/api/app.conf.js';
  export default {
    name: "index",
    data() {
      return {
        fooId:11010, activityId:179,redeemCode:'',total:0,copyTxt:'',getTimes:0,
        rst:0,
        url:'https://apph5.yymedias.com/appstore'
      };
    },
    mounted(){
      this.getCode();
    },
    watch:{
      redeemCode(val) {
        this.copyTxt = `送你7天VIP兑换码【${val}】，
        你想看的，这里都有，重要的事情说三遍，VIP免费！VIP免费！VIP免费看！
        戳我领取：${this.url}`
      }
    },
    methods:{
      showRule(){
        this.$yymd.yy2c(JSON.stringify({
          a:100,
          v:1,
          p:{"type":"1","url":location.origin+'/Activity/181'}
        }));
      },
      getCode(){
        fetch(API.U('get_redeem_code')).then(res => {
          if (res.status_code == 200) {
            let data = JSON.parse(decodeURIComponent(res.data));
            console.log(data);
            this.redeemCode = data.code;
            this.total = data.total;
            this.getTimes = data.get_times;
          }
        }).catch(ex=>{
          this.$dialog.notify({mes:'网络错误'});
        });
      },
      createCode(){
        this.$dialog.loading.open('正在领取...');
        this.$SPM(this.fooId,this.activityId, `.1`);
        fetch(API.U('create_code')).then(res=>{
          this.$dialog.loading.close();
          if (res.status_code == 200) {
            let data = JSON.parse(decodeURIComponent(res.data));
            this.redeemCode = data.code;
            this.total = data.total;
          } else if (res.status_code == 403) {
            this.$dialog.alert({
              mes: "请先登录", callback: () => {
                this.$yymd.yy2c('{"a":12,"v":1,"p":{}}', 0)
              }
            });
          } else {
            this.$dialog.alert({mes:'code:' + res.status_code + '错误' + res.message});
          }
        }).catch(ex=>{
          this.$dialog.loading.close();
        });
      },
      copy(){
        var clipboard = new Clipboard('.to-copy');
        clipboard.on('success', e => {
          clipboard.destroy()
          this.$dialog.alert({ mes: "兑换码口令已经复制，快分享给好基（huo）友（ban）吧！", callback: () => { } })
          // 释放内存
        })
        clipboard.on('error', e => {
          // 不支持复制
          console.log('该浏览器不支持自动复制', e)
          // 释放内存
          clipboard.destroy()
        });
        this.$SPM(this.fooId,this.activityId, `.2`);
      }
    }
  }
</script>

<style rel="stylesheet/less" lang="less" scoped>
.box {
  position: relative;
  &-item{
    position: relative;
    &-people {
      position:absolute; top:28%; color:#fff;
      width:100%; text-align: center;font-size:.4rem;
      span {font-size: 3em;}
    }
    &-rule {
      position:absolute; top:55%; color:#fff; width:30%;left:35%;height:20%;
      text-align: center;font-size:.4rem;
    }
  }
  &-get-vip {
    position:absolute;top:32%; left:10%; width:80%;
    height:68%;
    /*border:1px solid #000;*/
  }
  &-get-succ {
    position:absolute;top:32%; left:10%; width:80%;
    height:68%;
    img {width:50% !important;}text-align: center;
    &-time {
      position: absolute; top:33%;
      color:#FFD2D2;width:80%;left:10%;
      span{font-size: 2em; font-weight: bold;}
    }
    &-code {
      background-color: #fff;
      position: absolute; bottom:40%;width:80%;height:12%;left:10%; border-radius: 5px;
      font-size: .4rem;
      user-select: text;
      display: flex;
      align-items: center;
      /*实现水平居中*/
      justify-content: center;
    }
    /*border:1px solid #000;*/
  }
  &-btn {
    position:absolute; bottom:2%;left:5%; width:90% !important; height:35% !important;
    background-position: center;
    background-repeat: no-repeat;
    background-size:100% 100%;
    font-size:.6rem; font-weight: bold;letter-spacing:2px;
    display: flex;
    align-items: center;
    /*实现水平居中*/
    justify-content: center;
    color:#fff; text-align: center;
    padding-top: .2rem;
    line-height: .6em;
    div {font-size:.88em;}
    span {
      font-size:.2rem;
    }
  }
  img {
    width:100%;height:auto;
  }
}
</style>